import { showFlashingLightSection, showGateArmSection, showWarningSystemTime, showInsulJtsBonds } from "../bodyItems";
import React from "react";
import { Row, Col } from "reactstrap";
export const FirstSectionMonthly = (tests) => {
  let toShow = null;
  let sections = [
    showFlashingLightSection(tests["FlashingLight"]),
    showGateArmSection(tests["GateArms"]),
    showWarningSystemTime(tests["WarningSystemOperation"]),
    showInsulJtsBonds(tests["InsulJtsBonds"]),
  ];
  sections.forEach((item) => item && (toShow = true));
  if (toShow) {
    return (
      <React.Fragment>
        <Col md={12} className="border border-dark">
          <Row>
            <Col md={6}></Col>
            <Col md={6}>
              <div className="box-title">Condition</div>
            </Col>
          </Row>
          { !Array.isArray(tests.FlashingLight) && showFlashingLightSection(tests["FlashingLight"])}
          {!Array.isArray(tests.GateArms) && showGateArmSection(tests["GateArms"])}
          {showWarningSystemTime(tests["WarningSystemOperation"])}
          {showInsulJtsBonds(tests["InsulJtsBonds"])}
        </Col>
      </React.Fragment>
    );
  } else return null;
};



// WEBPACK FOOTER //
// ./src/components/Reports/sims/FRA_Crossing/FRA_CrossingReport/Sections/FirstSectionMonthly.jsx